import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="canvasrenderingcontext2d" id="canvasrenderingcontext2d"></a>
    <h1 {...{
      "id": "windowcanvasrenderingcontext2d"
    }}>{`window.CanvasRenderingContext2D`}</h1>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D"
      }}>{`Web APIs - CanvasRenderingContext2D`}</a>{` for more details`}<br></br>{`
Also, refer to the interface `}<a parentName="p" {...{
        "href": "../HTML%20Elements/HTMLCanvasElement.md#module:global.htmlcanvaselement"
      }}>{`HTMLCanvasElement`}</a><br></br><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v7.0.0  `}</p>
    <a name="new-canvasrenderingcontext2d-new" id="new-canvasrenderingcontext2d-new"></a>
    <h2 {...{
      "id": "canvasrenderingcontext2d"
    }}>{`CanvasRenderingContext2D()`}</h2>
    <p>{`Creates an instance of CanvasRenderingContext2D.`}</p>
    <a name="canvasrenderingcontext2d-linewidth" id="canvasrenderingcontext2d-linewidth"></a>
    <h2 {...{
      "id": "linewidth--number"
    }}>{`lineWidth : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p>{`Get the thickness of lines.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/lineWidth"
      }}>{`CanvasRenderingContext2D - lineWidth`}</a>{` for more details  `}</p>
    <a name="canvasrenderingcontext2d-linejoin" id="canvasrenderingcontext2d-linejoin"></a>
    <h2 {...{
      "id": "linejoin--string"
    }}>{`lineJoin : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p>{`Get the shape used to join two line segments where they meet.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/lineJoin"
      }}>{`CanvasRenderingContext2D - lineJoin`}</a>{` for more details  `}</p>
    <a name="canvasrenderingcontext2d-linecap" id="canvasrenderingcontext2d-linecap"></a>
    <h2 {...{
      "id": "linecap--string"
    }}>{`lineCap : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p>{`Get the shape used to draw the end points of lines.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/lineCap"
      }}>{`CanvasRenderingContext2D - lineCap`}</a>{` for more details  `}</p>
    <a name="canvasrenderingcontext2d-globalalpha" id="canvasrenderingcontext2d-globalalpha"></a>
    <h2 {...{
      "id": "globalalpha--number"
    }}>{`globalAlpha : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p>{`Get the global alpha(transparency) value.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalAlpha"
      }}>{`CanvasRenderingContext2D - globalAlpha`}</a>{` for more details  `}</p>
    <a name="canvasrenderingcontext2d-fillstyle" id="canvasrenderingcontext2d-fillstyle"></a>
    <h2 {...{
      "id": "fillstyle--string--canvasgradient"
    }}>{`fillStyle : `}<inlineCode parentName="h2">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="h2">{`CanvasGradient`}</inlineCode></h2>
    <p>{`Get the fill style used inside shapes.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fillStyle"
      }}>{`CanvasRenderingContext2D - fillStyle`}</a>{` for more details  `}</p>
    <a name="canvasrenderingcontext2d-strokestyle" id="canvasrenderingcontext2d-strokestyle"></a>
    <h2 {...{
      "id": "strokestyle--string"
    }}>{`strokeStyle : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p>{`Get the color to use for the strokes (outlines) around shapes.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/strokeStyle"
      }}>{`CanvasRenderingContext2D - strokeStyle`}</a>{` for more details  `}</p>
    <a name="canvasrenderingcontext2d-createlineargradient" id="canvasrenderingcontext2d-createlineargradient"></a>
    <h2 {...{
      "id": "createlineargradientx0-y0-x1-y1"
    }}>{`createLinearGradient(x0, y0, x1, y1)`}</h2>
    <p>{`Creates a gradient along the line connecting two given coordinates.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`CanvasGradient`}</inlineCode>{` - A linear CanvasGradient object initialized with the specified line.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`DOMException`}</inlineCode>{` `}</li>
    </ul>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/createLinearGradient"
      }}>{`CanvasRenderingContext2D - createLinearGradient`}</a>{` for more details  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`x0`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The x-axis coordinate of the start point.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`y0`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The y-axis coordinate of the start point.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`x1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The x-axis coordinate of the end point.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`y1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The y-axis coordinate of the end point.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="canvasrenderingcontext2d-createradialgradient" id="canvasrenderingcontext2d-createradialgradient"></a>
    <h2 {...{
      "id": "createradialgradientx0-y0-r0-x1-y1-r1"
    }}>{`createRadialGradient(x0, y0, r0, x1, y1, r1)`}</h2>
    <p>{`Creates a radial gradient using the size and coordinates of two circles.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`CanvasGradient`}</inlineCode>{` - A radial CanvasGradient object initialized with the two specified circles.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`DOMException`}</inlineCode>{` `}</li>
    </ul>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/createRadialGradient"
      }}>{`CanvasRenderingContext2D - createRadialGradient`}</a>{` for more details  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`x0`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The x-axis coordinate of the start circle.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`y0`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The y-axis coordinate of the start circle.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`r0`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The radius of the start circle. Must be non-negative and finite.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`x1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The x-axis coordinate of the end circle.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`y1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The y-axis coordinate of the end circle.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`r1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The radius of the end circle. Must be non-negative and finite.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="canvasrenderingcontext2d-beginpath" id="canvasrenderingcontext2d-beginpath"></a>
    <h2 {...{
      "id": "beginpath"
    }}>{`beginPath()`}</h2>
    <p>{`Creates a new path.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/beginPath"
      }}>{`CanvasRenderingContext2D - beginPath`}</a>{` for more details  `}</p>
    <a name="canvasrenderingcontext2d-closepath" id="canvasrenderingcontext2d-closepath"></a>
    <h2 {...{
      "id": "closepath"
    }}>{`closePath()`}</h2>
    <p>{`Add a straight line from the current point to the start of the current sub-path.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/closePath"
      }}>{`CanvasRenderingContext2D - closePath`}</a>{` for more details  `}</p>
    <a name="canvasrenderingcontext2d-moveto" id="canvasrenderingcontext2d-moveto"></a>
    <h2 {...{
      "id": "movetox-y"
    }}>{`moveTo(x, y)`}</h2>
    <p>{`Begins a new sub-path at the point specified by the given (x, y) coordinates.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/moveTo"
      }}>{`CanvasRenderingContext2D - moveTo`}</a>{` for more details  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`x`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The x-axis (horizontal) coordinate of the point.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`y`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The y-axis (vertical) coordinate of the point.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="canvasrenderingcontext2d-lineto" id="canvasrenderingcontext2d-lineto"></a>
    <h2 {...{
      "id": "linetox-y"
    }}>{`lineTo(x, y)`}</h2>
    <p>{`Adds a straight line to the current sub-path by connecting the sub-path's
last point to the specified (x, y) coordinates.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/lineTo"
      }}>{`CanvasRenderingContext2D - lineTo`}</a>{` for more details  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`x`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The x-axis coordinate of the line's end point.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`y`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The y-axis coordinate of the line's end point.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="canvasrenderingcontext2d-arc" id="canvasrenderingcontext2d-arc"></a>
    <h2 {...{
      "id": "arcx-y-radius-startangle-endangle-counterclockwise"
    }}>{`arc(x, y, radius, startAngle, endAngle, counterclockwise)`}</h2>
    <p>{`Adds a circular arc to the current sub-path.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/arc"
      }}>{`CanvasRenderingContext2D - arc`}</a>{` for more details  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`x`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The horizontal coordinate of the arc's center.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`y`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The vertical coordinate of the arc's center.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`radius`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The arc's radius. Must be positive.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`startAngle`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The angle at which the arc starts in radians, measured from the positive x-axis.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`endAngle`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The angle at which the arc ends in radians, measured from the positive x-axis.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`counterclockwise`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An optional boolean value. If true, draws the arc counter-clockwise between the start and end angles. The default is false (clockwise).`}</td>
        </tr>
      </tbody>
    </table>
    <a name="canvasrenderingcontext2d-arcto" id="canvasrenderingcontext2d-arcto"></a>
    <h2 {...{
      "id": "arctox1-y1-x2-y2-radius"
    }}>{`arcTo(x1, y1, x2, y2, radius)`}</h2>
    <p>{`Adds a circular arc to the current sub-path, using the given control points and radius.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/arcTo"
      }}>{`CanvasRenderingContext2D - arcTo`}</a>{` for more details  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`x1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The x-axis coordinate of the first control point.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`y1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The y-axis coordinate of the first control point.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`x2`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The x-axis coordinate of the second control point.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`y2`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The y-axis coordinate of the second control point.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`radius`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The arc's radius. Must be non-negative.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="canvasrenderingcontext2d-beziercurveto" id="canvasrenderingcontext2d-beziercurveto"></a>
    <h2 {...{
      "id": "beziercurvetocp1x-cp1y-cp2x-cp2y-x-y"
    }}>{`bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y)`}</h2>
    <p>{`Adds a cubic Bézier curve to the current sub-path.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/bezierCurveTo"
      }}>{`CanvasRenderingContext2D - bezierCurveTo`}</a>{` for more details  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`cp1x`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The x-axis coordinate of the first control point.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`cp1y`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The y-axis coordinate of the first control point.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`cp2x`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The x-axis coordinate of the second control point.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`cp2y`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The y-axis coordinate of the second control point.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`x`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The x-axis coordinate of the end point.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`y`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The y-axis coordinate of the end point.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="canvasrenderingcontext2d-quadraticcurveto" id="canvasrenderingcontext2d-quadraticcurveto"></a>
    <h2 {...{
      "id": "quadraticcurvetocpx-cpy-x-y"
    }}>{`quadraticCurveTo(cpx, cpy, x, y)`}</h2>
    <p>{`Adds a quadratic Bézier curve to the current sub-path.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/quadraticCurveTo"
      }}>{`CanvasRenderingContext2D - quadraticCurveTo`}</a>{` for more details  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`cpx`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The x-axis coordinate of the control point.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`cpy`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The y-axis coordinate of the control point.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`x`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The x-axis coordinate of the end point.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`y`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The y-axis coordinate of the end point.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="canvasrenderingcontext2d-rect" id="canvasrenderingcontext2d-rect"></a>
    <h2 {...{
      "id": "rectx-y-width-height"
    }}>{`rect(x, y, width, height)`}</h2>
    <p>{`Adds a rectangle to the current path.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/rect"
      }}>{`CanvasRenderingContext2D - rect`}</a>{` for more details  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`x`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The x-axis coordinate of the rectangle's starting point.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`y`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The y-axis coordinate of the rectangle's starting point.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`width`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The rectangle's width.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`height`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The rectangle's height.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="canvasrenderingcontext2d-stroke" id="canvasrenderingcontext2d-stroke"></a>
    <h2 {...{
      "id": "strokepath"
    }}>{`stroke(path)`}</h2>
    <p>{`Strokes (outlines) the current or given path with the current stroke style.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/stroke"
      }}>{`CanvasRenderingContext2D - stroke`}</a>{` for more details  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`path`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Path2D`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An optional Path2D object to stroke.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="canvasrenderingcontext2d-fill" id="canvasrenderingcontext2d-fill"></a>
    <h2 {...{
      "id": "fillpathorfillrule"
    }}>{`fill(pathOrFillRule)`}</h2>
    <p>{`Fills the current or given path with the current fillStyle.`}<br></br></p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fill"
      }}>{`CanvasRenderingContext2D - fill`}</a>{` for more details  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`pathOrFillRule`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Path2D`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An optional Path2D object to fill or String which defines an algorithm to determine if a point is inside or outside the filling region.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="canvasrenderingcontext2d-fillrect" id="canvasrenderingcontext2d-fillrect"></a>
    <h2 {...{
      "id": "fillrectx-y-width-height"
    }}>{`fillRect(x, y, width, height)`}</h2>
    <p>{`Draws a rectangle that is filled according to the current fillStyle.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fillRect"
      }}>{`CanvasRenderingContext2D - fillRect`}</a>{` for more details  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`x`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The x-axis coordinate of the rectangle's starting point.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`y`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The y-axis coordinate of the rectangle's starting point.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`width`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The rectangle's width.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`height`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The rectangle's height.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="canvasrenderingcontext2d-strokerect" id="canvasrenderingcontext2d-strokerect"></a>
    <h2 {...{
      "id": "strokerectx-y-width-height"
    }}>{`strokeRect(x, y, width, height)`}</h2>
    <p>{`Draws a rectangle that is stroked (outlined) according to the current strokeStyle`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/strokeRect"
      }}>{`CanvasRenderingContext2D - strokeRect`}</a>{` for more details  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`x`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The x-axis coordinate of the rectangle's starting point.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`y`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The y-axis coordinate of the rectangle's starting point.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`width`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The rectangle's width.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`height`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The rectangle's height.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="canvasrenderingcontext2d-clearrect" id="canvasrenderingcontext2d-clearrect"></a>
    <h2 {...{
      "id": "clearrectx-y-width-height"
    }}>{`clearRect(x, y, width, height)`}</h2>
    <p>{`Erases the pixels in a rectangular area by setting them to transparent black.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/clearRect"
      }}>{`CanvasRenderingContext2D - clearRect`}</a>{` for more details  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`x`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The x-axis coordinate of the rectangle's starting point.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`y`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The y-axis coordinate of the rectangle's starting point.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`width`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The rectangle's width.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`height`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The rectangle's height.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      